import { TOKEN_CREATOR_TOGGLE_TRACK_CLASS } from "../constants";

export default function ToggleSwitch({
  checked,
  onChange,
  label,
  description,
  price,
  icon: Icon,
}) {
  return (
    <div className="space-y-3 rounded-2xl border border-gray-800 bg-gray-950/60 p-4 sm:p-5">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div className="flex min-w-0 flex-1 items-center gap-2.5 text-white pr-1">
          {Icon && (
            <Icon className="h-4 w-4 shrink-0 text-cyan-300" />
          )}
          <div className="min-w-0 flex-1">
            <span className="break-words text-sm font-semibold sm:text-base">
              {label}
            </span>
            {price && (
              <span className="ml-2 whitespace-nowrap text-xs font-semibold text-cyan-300 sm:text-sm">
                (+{price} SOL)
              </span>
            )}
          </div>
        </div>
        <label className="relative inline-flex shrink-0 cursor-pointer items-center self-start sm:self-center">
          <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            className="peer sr-only"
          />
          <div className={TOKEN_CREATOR_TOGGLE_TRACK_CLASS} />
        </label>
      </div>
      {description && (
        <p className="text-xs text-gray-400">{description}</p>
      )}
    </div>
  );
}
